import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { v4 as uuid } from 'uuid';

@Injectable()
export class WaitingService extends BehaviorSubject<boolean> {
	private currentRequestsIds: string[] = [];

	constructor() {
		super(false);
	}

    /**
     * Démarre le cahrgement
     * @returns `string` waitingId
     */
	start() {
		const id = uuid();
		this.currentRequestsIds.push(id);

		if (this.currentRequestsIds.length > 0) this.next(true);

		return id;
	}

    /**
     * Met fin au chargement
     * @param id waitingId généré au `.start()`
     */
	end(id: string) {
		const idIndex = this.currentRequestsIds.indexOf(id);
		if (idIndex > -1) this.currentRequestsIds.splice(idIndex, 1);

		if (this.currentRequestsIds.length === 0) this.next(false);
	}
}
